var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 22.405881881713867,
    viewBox: "0 0 24 22.405881881713867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_17_1449"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 22.405881881713867,
    rx: 0
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_17_1449)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.933578,3.73431396484375L20.0664,3.73431396484375C20.582,3.73431396484375,21,4.15229096484375,21,4.66789196484375C21,5.18349396484375,20.582,5.60147396484375,20.0664,5.60147396484375L3.933578,5.60147396484375C3.417977,5.60147396484375,3,5.18349396484375,3,4.66789196484375C3,4.15229096484375,3.417977,3.73431396484375,3.933578,3.73431396484375M3.933579,10.26936396484375L14.0664,10.26936396484375C14.582,10.26936396484375,15,10.68734396484375,15,11.202943964843751C15,11.71854396484375,14.582,12.13652396484375,14.0664,12.13652396484375L3.933579,12.13652396484375C3.417977,12.13652396484375,3,11.71854396484375,3,11.202943964843751C3,10.68734396484375,3.417977,10.26936396484375,3.933579,10.26936396484375M3.933578,16.80441396484375L20.0664,16.80441396484375C20.582,16.80441396484375,21,17.22241396484375,21,17.738013964843752C21,18.25361396484375,20.582,18.67161396484375,20.0664,18.67161396484375L3.933578,18.67161396484375C3.417977,18.67161396484375,3,18.25361396484375,3,17.738013964843752C3,17.22241396484375,3.417977,16.80441396484375,3.933578,16.80441396484375",
    fill: "#5F5F5F",
    fillOpacity: 1,
    style: {
      mixBlendMode: "passthrough"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.d271f352ab3c0b4bd2108962e088b92b.svg";
export { ForwardRef as ReactComponent };